import { useMutation } from "@tanstack/react-query";
import { createArea } from "src/Pages/Company/OrganizationStructure/api";
import { useHistory } from "react-router-dom";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import { ICreateArea } from "src/Pages/Company/OrganizationStructure/Areas/Area.models";
import { useContext } from "react";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";

const useCreateArea = (companyId: string, structureId: string | undefined) => {
  const history = useHistory();
  const { userInfo } = useContext(RbsContext);
  const isAhr = userInfo.isAhr();

  return useMutation({
    mutationFn: async (formData: ICreateArea) =>
      createArea(companyId, structureId!, formData),
    onSuccess: () => {
      dynamicNotification(__("Pomyślnie zapisano dane"), "success");
      history.push(
        isAhr
          ? `/ahr/organization-structure/configure-structure/structure-areas`
          : `/company/edit/${companyId}/organization-structure/configure-structure/structure-areas`
      );
    },
  });
};

export default useCreateArea;
